import React, { useEffect, useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import { ImageElement } from "../UiElement";
import { Link } from "react-router-dom";

function UserLandingHeader() {
  useEffect(() => {
    setTimeout(() => {
      let navbar = document.querySelector(".mainHeader").clientHeight;
      document.querySelector("body").style.paddingTop = `${navbar}px`;
    }, 300);
  });
  const [scroll, setScroll] = useState(0);
  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 50
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck)
      }
    })
  });
  return (
    <>
      <header className={`mainHeader ${scroll ? 'scroll' : ''}`}>
        <Container>
          <Navbar className="p-0" aria-label="Main Menu">
            <Navbar.Brand href="/user-landing" aria-label="Logo" className="m-0 p-0"><ImageElement source="logo-sidebar.svg" alt="logo" isLightbox={false} /></Navbar.Brand>
            <div className="ms-auto">
              <Link to="/login" target="_blank" className="btn btn-primary" >Login</Link>
            </div>
          </Navbar>
        </Container>
      </header>
    </>
  );
}

export default UserLandingHeader;
